export default __webpack_public_path__ + "static/media/speed-banners-cn.6093130b.webp";